module.exports = __webpack_public_path__ + "img/augers.6ff7e997.jpg";